define('apps/admin/views/audience-guid',[
        'njs!apps/admin/templates/includes/_audience_guid(params:tmpl=admin/main/includes/_audience_guid.html)',
    ], function(template) {
        'use strict';

        return Mn.ItemView.extend({

            "template": template,

            "tagName": "div",

            "className": function() {
                var type = this.model.get('type');
                return type + "-item";
            },

            "events": {
                "click .create-remove-guid": "removeGuid",
            },

            "removeGuid": function(e) {
                e.preventDefault();
                $(e.currentTarget).parent().remove();
            }
        });
});

